// Worker plan tiers, as returned in `plan_id` on the login API response.
export const ATTENDANCE_PLAN_IDS = ['attendance_monthly', 'attendance_yearly', 'free'];
export const TASKS_PLAN_IDS = ['tasks_monthly', 'tasks_yearly'];
export const FULL_PLAN_IDS = ['full_monthly', 'full_yearly'];

// Tasks module is unlocked by the tasks plan or the full plan.
export const hasTasksAccess = (planId) =>
  TASKS_PLAN_IDS.includes(planId) || FULL_PLAN_IDS.includes(planId);

// Request management (and everything else not covered by attendance/tasks) needs the full plan.
export const hasFullAccess = (planId) => FULL_PLAN_IDS.includes(planId);
